module.exports = __webpack_public_path__ + "img/mean4.9a7dcf30.png";